import CryptoJS from 'crypto-js'

export function encryption(params) {
  const data = params.data
  const type = params.type
  const param = params.param
  var key1 = params.key
  const result = JSON.parse(JSON.stringify(data))
  if (type === 'Base64') {
    param.forEach(ele => {
      result[ele] = btoa(result[ele])
    })
  } else {
    param.forEach(ele => {
      var data = result[ele]
      const key = CryptoJS.enc.Latin1.parse(key1)
      var iv = key
      // 加密
      console.log(iv, key, '加密')
      var encrypted = CryptoJS.AES.encrypt(
        data,
        key, {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.ZeroPadding
        })
      result[ele] = encrypted.toString()
    })
  }
  return result
}
// 解密
export function getDAesString(encrypted, key) {
  const key1 = CryptoJS.enc.Latin1.parse(key)
  var iv = key1
  var decrypted = CryptoJS.AES.decrypt(encrypted, key1,
    {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.ZeroPadding
    })
  return decrypted.toString(CryptoJS.enc.Utf8)
}
